import {
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
} from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';

type Props = {
  data?: Array<{
    title: any;
    content: any;
    children?: any;
    anim?: string;
    onClickTab?: (e?: any) => void;
  }>;
  currentTab?: number;
  hideHeader?: boolean;
  contentAfterTabs?: JSX.Element | null;
  searchBar?: JSX.Element | null;
  rigthButton?: JSX.Element | null;
  backgroundTabsSticky?: JSX.Element | null;
  currentTabsClassName?: string;
  indicatorActiveClassName?: string;
  isSticky?: boolean;
  shouldGoBellow?: boolean;
};

export const TabBars = (props: Props) => {
  const {
    data,
    currentTab,
    contentAfterTabs,
    rigthButton,
    searchBar,
    hideHeader,
    currentTabsClassName,
    indicatorActiveClassName,
    backgroundTabsSticky,
    isSticky,
    shouldGoBellow,
  } = props;
  const [activeTab, setActiveTab] = React.useState(currentTab);
  const [addAnim, setAddnim] = useState(false);
  useEffect(() => {
    if (currentTab) {
      setActiveTab(currentTab);
      setAddnim(true);
    }

    return () => {
      setActiveTab(0);
    };
  }, []);

  return (
    <div
      className={` ${
        isSticky && ' sticky top-[-2px]  z-10   clip-inset  '
      } mb-3 relative ${shouldGoBellow ? 'z-[1]' : 'z-10'}`}
    >
      <Tabs value={activeTab} className="overflow-visible ">
        <div
          className={` ${
            backgroundTabsSticky && ' sticky top-[-2px]  z-10   clip-inset  '
          } py-3`}
        >
          <TabsHeader
            className="bg-transparent py-0 gap-4 "
            indicatorProps={{
              className: `${
                indicatorActiveClassName
                  ? indicatorActiveClassName
                  : 'bg-neutral-40 shadow-none  '
              }!rounded-borderRadius10 `,
            }}
            placeholder={''}
          >
            {!hideHeader
              ? data?.map((item, index) => (
                  <Tab
                    key={index}
                    value={index}
                    onClick={() => {
                      setActiveTab(index);
                      if (item.onClickTab) {
                        item.onClickTab(index);
                      }
                    }}
                    className={`h-10 rounded-borderRadius10  ${
                      activeTab === index
                        ? currentTabsClassName
                          ? currentTabsClassName
                          : 'text-white '
                        : ''
                    }  !leading-[1] `}
                    placeholder={''}
                  >
                    {item.title}
                  </Tab>
                ))
              : null}
            {rigthButton && (
              <div className="w-full z-10 flex justify-end items-center">
                {rigthButton}{' '}
              </div>
            )}
          </TabsHeader>
          {(rigthButton || searchBar) && (
            <div
              className={
                'absolute h-[400px] w-full  z-[8] bg-inputBackground top-0 '
              }
            />
          )}
          {backgroundTabsSticky}
        </div>

        <TabsBody className="overflow-visible" placeholder={''}>
          {searchBar && (
            <div
              className={
                'sticky top-[60px]  z-10 px-6 mx-[-24px]   clip-inset  pb-4 '
              }
            >
              <div
                className={
                  'absolute h-[400px] w-full  z-[-1] bg-inputBackground '
                }
              />
              {searchBar}
            </div>
          )}
          {data?.map((item, index) => (
            <TabPanel
              key={`${item.title} ${Math.random()}`}
              value={index}
              className="p-0"
            >
              <div className={`${addAnim ? item.anim : null} pb-1 p-0 `}>
                {currentTab
                  ? index === currentTab && item.content
                  : item.content}
              </div>
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
      {isSticky && (
        <div
          className={
            'absolute h-[400px] top-0 w-full  z-[-1] bg-inputBackground '
          }
        />
      )}

      {contentAfterTabs && <div className="mt-3 ">{contentAfterTabs}</div>}
    </div>
  );
};

TabBars.defaultProps = {
  data: [
    {
      title: <></>,
      content: <></>,
      children: <></>,
      onClickTab: (e: any) => ({}),
    },
  ],
  currentTab: 0,
  contentAfterTabs: null,
  searchBar: null,
};

export default TabBars;
